import { render, staticRenderFns } from "./changeStatus.vue?vue&type=template&id=ccfc6f60"
import script from "./changeStatus.vue?vue&type=script&lang=js"
export * from "./changeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports